//External
import React from "react";

//Internal
import userDefaultPhoto from "../../public/assets/images/user.jpeg";

/*******************
@Purpose : Used for user avatar (profile photo or initials)
@Parameter : { userInfo, className }
@Author : INIC
******************/
function UserAvatar({ userInfo, className = "" }) {
  const initials = (
    (userInfo?.first_name ? userInfo?.first_name["0"] : "") +
    (userInfo?.last_name ? userInfo?.last_name["0"] : "")
  ).toUpperCase();

  const classes = ["avatar", userInfo?.photo && "has-photo", className]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={classes}>
      {userInfo?.photo ? (
        <img
          src={userInfo?.photo}
          className="object-cover"
          loading="lazy"
          alt="User img"
        />
      ) : initials ? (
        <span className="avatar-initials">{initials}</span>
      ) : (
        <img
          src={userDefaultPhoto}
          className="object-cover"
          loading="lazy"
          alt="User img"
        />
      )}
    </div>
  );
}

export default UserAvatar;
